import { useDispatch } from 'react-redux';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { LoadingModal, MessageModal } from './component/modal/modal';
import { isValidCardNumber } from './common/function';
import { buildPolicyMap, filterInstallmentOptions, getPolicyNotice, isQuotaAllowed, makePolicyFromMerchantPolicy } from './common/manualCardPolicy';
import { Search, X } from 'lucide-react';

function Sugi() {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [bank, setBank] = useState("");
    const [cardPolicyMap, setCardPolicyMap] = useState({});
    const [feeImage, setFeeImage] = useState([]);
    const [noticeModal, setNoticeModal] = useState(false);

    // ▼ (1) 요청 중복 방지
    const [isSubmitting, setIsSubmitting] = useState(false);

    // =======================
    // formData (실제 전송 값)
    // =======================
    const [formData, setFormData] = useState({
        GoodsName: "",
        Amt: "", // API 전송 시 콤마 없이 숫자만
        BuyerName: "",
        BuyerEmail: "",
        BuyerHpTel: "", // 휴대폰 번호 (숫자만)
        card_num: "",   // 카드번호 (숫자만) - 아래 4개 input을 합쳐 저장
        CardCvv: "",
        CardPw: "",
        ExpMonth: "",
        ExpYear: "",
        card_gubun: "개인",
        IDNo: "",
        CardQuota: "00",
    });

    // (1) 금액 표시용 (천단위 콤마)
    const [displayAmt, setDisplayAmt] = useState("");

    // (2) 휴대폰번호 표시용 ("010-1234-5678")
    const [phoneDisplayValue, setPhoneDisplayValue] = useState("");

    // -- (3) 카드번호를 4개 input으로 분할해서 관리 --
    const [cardNum1, setCardNum1] = useState("");
    const [cardNum2, setCardNum2] = useState("");
    const [cardNum3, setCardNum3] = useState("");
    const [cardNum4, setCardNum4] = useState("");

    // 각 카드번호 input에 대한 ref (자동 포커스 이동용)
    const cardNum1Ref = useRef(null);
    const cardNum2Ref = useRef(null);
    const cardNum3Ref = useRef(null);
    const cardNum4Ref = useRef(null);

    const [Window, setWindow] = useState(true);
    const isKayu = JSON.parse(localStorage.getItem("userId"))?.kayu == 1;

    useEffect(() => {
        dispatch(change_Current_Location("수기결제"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "수기결제",
                subTitle: "",
            })
        );

        setTimeout(() => {
            setLoading(false);
        }, 500);

        CheckFee();
        CheckManualCardPolicy();

        // 반응형 처리
        const handleResize = () => {
            if (window.innerWidth >= 1280) setWindow(true);
            else setWindow(false);
        };
        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [dispatch]);

    // 카드 수수료 정보 조회
    const CheckFee = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/card/fee-info",
                {
                    withCredentials: true,
                }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setFeeImage(tmp?.data?.feeInfo);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    const CheckManualCardPolicy = async () => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/manual-card-policy/list",
                {},
                { withCredentials: true }
            );
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setCardPolicyMap(buildPolicyMap(tmp?.data?.policies ?? []));
            } else if (tmp?.code === 9999) {
                navigate("/");
            } else {
                setCardPolicyMap({});
            }
        } catch (error) {
            console.error(error);
            setCardPolicyMap({});
        }
    };

    // 카드사 조회 (카드번호 8자리 이상일 때)
    const CheckBank = async (eightDigits) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/card/card-info",
                {
                    withCredentials: true,
                    params: {
                        cardNumber: eightDigits,
                    },
                }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setBank(tmp?.data[0]?.card ?? "");
            } else if (tmp?.code === 9999) {
                navigate("/");
            } else {
                setBank("유효하지 않습니다.");
            }
        } catch (error) {
            console.error(error);
            setBank("");
        }
    };

    // =======================
    // (1) 금액 입력: 콤마 표시
    // =======================
    const handleAmtChange = (e) => {
        let val = e.target.value;
        // 숫자만 추출
        let numeric = val.replace(/\D/g, "");
        // 최대 9자리 제한
        numeric = numeric.slice(0, 9);

        // 실제 formData.Amt에는 숫자만 저장
        setFormData((prev) => ({
            ...prev,
            Amt: numeric,
        }));

        // 화면 표시용
        if (!numeric) {
            setDisplayAmt("");
        } else {
            setDisplayAmt(parseInt(numeric, 10).toLocaleString("ko-KR"));
        }
    };

    // =======================
    // (2) 휴대폰번호 입력: 3-4-4
    // =======================
    const handlePhoneChange = (e) => {
        let val = e.target.value;
        // 숫자만
        let numeric = val.replace(/\D/g, "");
        // 최대 11자리 제한
        numeric = numeric.slice(0, 11);

        // 3-4-4 형태로 나누기
        let parted = [];
        if (numeric.length < 4) {
            parted = [numeric];
        } else if (numeric.length < 8) {
            parted = [numeric.slice(0, 3), numeric.slice(3)];
        } else {
            parted = [numeric.slice(0, 3), numeric.slice(3, 7), numeric.slice(7)];
        }
        let displayVal = parted.join("-");

        setPhoneDisplayValue(displayVal);
        setFormData((prev) => ({
            ...prev,
            BuyerHpTel: numeric, // 숫자만
        }));
    };

    // =======================
    // (3) 카드번호 입력을 4개 input으로 분할
    // =======================
    // 첫 번째 필드
    const handleCardInput1 = (e) => {
        let val = e.target.value.replace(/\D/g, "");
        val = val.slice(0, 4);
        setCardNum1(val);

        // 4자리가 차면 다음 필드로 포커스
        if (val.length === 4) {
            cardNum2Ref.current?.focus();
        }
    };

    // 두 번째 필드
    const handleCardInput2 = (e) => {
        let val = e.target.value.replace(/\D/g, "");
        val = val.slice(0, 4);
        setCardNum2(val);

        if (val.length === 4) {
            cardNum3Ref.current?.focus();
        }
    };

    // 세 번째 필드
    const handleCardInput3 = (e) => {
        let val = e.target.value.replace(/\D/g, "");
        val = val.slice(0, 4);
        setCardNum3(val);

        if (val.length === 4) {
            cardNum4Ref.current?.focus();
        }
    };

    // 네 번째 필드
    const handleCardInput4 = (e) => {
        let val = e.target.value.replace(/\D/g, "");
        val = val.slice(0, 4);
        setCardNum4(val);
    };

    // 카드번호 4개의 상태가 변할 때마다 formData.card_num에 합쳐서 저장
    // + 8자리 이상이면 카드사 조회
    useEffect(() => {
        const combined = cardNum1 + cardNum2 + cardNum3 + cardNum4;
        setFormData((prev) => ({
            ...prev,
            card_num: combined, // 숫자만
        }));

        if (combined.length >= 8) {
            CheckBank(combined.slice(0, 8));
        } else {
            setBank("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cardNum1, cardNum2, cardNum3, cardNum4]);

    // 다른 일반 input 처리 (예: BuyerName, CardCvv 등)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const quotaOptions = [
        { value: "00", label: "일시불" },
        ...Array.from({ length: 12 }, (_, i) => {
            const month = i + 1;
            const padded = String(month).padStart(2, "0");
            return { value: padded, label: `${month}개월` };
        }),
    ];
    const currentCardPolicy = makePolicyFromMerchantPolicy(bank, cardPolicyMap[bank]);
    const currentQuotaOptions = filterInstallmentOptions(quotaOptions, currentCardPolicy?.max_installment);
    const cardPolicyNotice = getPolicyNotice(currentCardPolicy);
    const isCardBlocked = currentCardPolicy?.usable === false;

    useEffect(() => {
        if (!isQuotaAllowed(formData.CardQuota, currentCardPolicy?.max_installment)) {
            setFormData((prev) => ({ ...prev, CardQuota: "00" }));
        }
    }, [currentCardPolicy?.max_installment, formData.CardQuota]);

    // =======================
    // 결제 요청
    // =======================
    const onSubmitSugi = async () => {
        if (isSubmitting) return; // 중복 클릭 방지
        if (!isValidCardNumber(formData.card_num)) {
            setMessage({ msg: "카드번호를 확인해주세요." });
            return;
        }
        if (isCardBlocked) {
            setMessage({ msg: cardPolicyNotice || "해당 카드는 사용할 수 없습니다." });
            return;
        }
        setIsSubmitting(true);
        setLoading(true);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi",
                {
                    payerName: formData.BuyerName,
                    payerEmail: formData.BuyerEmail,
                    payerTel: formData.BuyerHpTel,  // 숫자만
                    cardNumber: formData.card_num,  // 4칸 합친 숫자만
                    cardExpiry: formData.ExpYear + formData.ExpMonth,
                    cardCvv: formData.CardCvv,
                    installment: formData.CardQuota,
                    products: [
                        {
                            prodId: "",
                            name: formData.GoodsName,
                            qty: 1,
                            price: formData.Amt, // 숫자만
                            desc: "수기결제",
                        },
                    ],
                    metadata: {
                        cardAuth: "true",
                        authPw: formData.CardPw,
                        authDob: formData.IDNo,
                    },
                    amount: formData.Amt, // 숫자만
                },
                {
                    withCredentials: true,
                }
            );

            let tmp = response?.data;
            if (tmp?.code < 2000) {
                // 결제 요청 성공 시 폼 초기화
                setFormData({
                    GoodsName: "",
                    Amt: "",
                    BuyerName: "",
                    BuyerEmail: "",
                    BuyerHpTel: "",
                    card_num: "",
                    CardCvv: "",
                    CardPw: "",
                    ExpMonth: "",
                    ExpYear: "",
                    IDNo: "",
                    CardQuota: "00",
                    card_gubun: "개인",
                });
                setBank("");
                setDisplayAmt("");
                setPhoneDisplayValue("");
                // 카드번호 필드 초기화
                setCardNum1("");
                setCardNum2("");
                setCardNum3("");
                setCardNum4("");

                setMessage({ msg: "수기결제성공" });
            } else {
                const result = tmp?.data?.response?.result;
                setMessage({
                    msg:
                        result?.advanceMsg?.trim() ||
                        result?.resultMsg?.trim() ||
                        tmp?.msg ||
                        "수기결제실패",
                });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: error?.response?.data?.msg || "결제 요청 중 오류가 발생했습니다." });
        } finally {
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    return (
        <div className="flex overflow-hidden">
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            {noticeModal && !Window && (
                <NoticeModal feeImage={feeImage} setNoticeModal={setNoticeModal} />
            )}

            <div className="content" id="contents">
                <div className="payment">
                    <div className="inner-wrap h-full">
                        <div
                            className="content-wrap h-full"
                            style={{ padding: "0", gap: "20px" }}
                        >
                            <form
                                className="content-item payForm active"
                                name="payForm"
                                id="payForm"
                                method="post"
                                acceptCharset="UTF-8"
                                autoComplete="off"
                                noValidate
                            >
                                <div
                                    className="intro-y box"
                                    style={{
                                        height: Window ? "" : "calc(100dvh - 4.5rem)",
                                        minHeight: "620px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "10px",
                                            alignItems: "center",
                                            padding: "0px",
                                            borderBottom: "1px solid #E5E5E5",
                                            backgroundColor: "#fff",
                                            marginBottom: "15px"
                                        }}
                                    >
                                        <button
                                            className="tab-btn active"
                                            style={{
                                                padding: "12px 10px 8px",
                                                fontSize: "17px",
                                                fontWeight: "600",
                                                color: "#222",
                                                background: "transparent",
                                                border: "none",
                                                borderBottom: "3px solid #3182F6",
                                                transition: "all 0.2s ease-in-out",
                                                cursor: "pointer",
                                            }}
                                        >
                                            수기결제
                                        </button>
                                    </div>
                                    {/* <h2 className="title w-full">결제하기</h2> */}
                                    {/* 크롬 자동완성 방지용 */}
                                    <input
                                        type="password"
                                        style={{ display: "none" }}
                                        readOnly
                                    />

                                    {/* 카드번호를 4개 input으로 나눈 영역 */}
                                    <div className="input_w_70 input">
                                        <label
                                            htmlFor="card_num"
                                            className="form-label"
                                            style={{ width: "100%" }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                }}
                                            >
                                                <div>신용카드번호</div>
                                                <div
                                                    style={{
                                                        color: "red",
                                                        fontSize: "12px",
                                                        marginTop: "5px",
                                                        height: "20px",
                                                    }}
                                                >
                                                    {bank.length > 0 ? `* ${cardPolicyNotice || bank}` : ""}
                                                </div>
                                            </div>
                                        </label>

                                        {/* 실제로는 4개의 input으로 분리 */}
                                        <div style={{ display: "flex", gap: "5px" }}>
                                            <input
                                                ref={cardNum1Ref}
                                                type="text"
                                                className="form-control big-input"
                                                maxLength={4}
                                                placeholder="0000"
                                                value={cardNum1}
                                                onChange={handleCardInput1}
                                            />
                                            <input
                                                ref={cardNum2Ref}
                                                type="text"
                                                className="form-control big-input"
                                                maxLength={4}
                                                placeholder="0000"
                                                value={cardNum2}
                                                onChange={handleCardInput2}
                                            />
                                            <input
                                                ref={cardNum3Ref}
                                                type="text"
                                                className="form-control big-input"
                                                maxLength={4}
                                                placeholder="0000"
                                                value={cardNum3}
                                                onChange={handleCardInput3}
                                            />
                                            <input
                                                ref={cardNum4Ref}
                                                type="text"
                                                className="form-control big-input"
                                                maxLength={4}
                                                placeholder="0000"
                                                value={cardNum4}
                                                onChange={handleCardInput4}
                                            />
                                        </div>
                                        {cardPolicyNotice && (
                                            <div style={{ color: isCardBlocked ? "#dc3545" : "#2563eb", fontSize: "12px", marginTop: "6px", fontWeight: "600" }}>
                                                {cardPolicyNotice}
                                            </div>
                                        )}
                                    </div>

                                    {/* 카드비밀번호 / 유효기간 */}
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "0.5rem",
                                            width: "100%",
                                        }}
                                    >
                                        <div
                                            className="input_w_55 input"
                                            style={{ width: isKayu ? "100%" : "67%" }}
                                        >
                                            <label
                                                htmlFor="ExpMonth"
                                                className="form-label"
                                            >
                                                카드 유효기간 (월/년)
                                            </label>
                                            <div className="multiple">
                                                <input
                                                    id="ExpMonth"
                                                    name="ExpMonth"
                                                    type="text"
                                                    className="form-control big-input"
                                                    maxLength={2}
                                                    placeholder="월"
                                                    value={formData.ExpMonth}
                                                    onChange={handleChange}
                                                />
                                                <span>/</span>
                                                <input
                                                    id="ExpYear"
                                                    name="ExpYear"
                                                    type="text"
                                                    className="form-control big-input"
                                                    maxLength={4}
                                                    placeholder="년"
                                                    value={formData.ExpYear}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        {!isKayu && (
                                        <div
                                            className="input_w_30 input"
                                            style={{ width: "33%" }}
                                        >
                                            <label
                                                htmlFor="CardPw"
                                                className="form-label"
                                            >
                                                카드비밀번호
                                            </label>
                                            <input
                                                id="CardPw"
                                                name="CardPw"
                                                type="password"
                                                className="form-control big-input"
                                                maxLength={2}
                                                placeholder="앞2자리"
                                                autoComplete="new-password"
                                                value={formData.CardPw}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        )}
                                    </div>

                                    {/* 상품명 / 금액 */}
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "0.5rem",
                                            width: "100%",
                                        }}
                                    >
                                        <div className="input">
                                            <label
                                                htmlFor="GoodsName"
                                                className="form-label"
                                            >
                                                상품정보
                                            </label>
                                            <input
                                                id="GoodsName"
                                                name="GoodsName"
                                                type="text"
                                                className="form-control big-input"
                                                placeholder="상품명 입력"
                                                value={formData.GoodsName}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="input">
                                            <label
                                                htmlFor="Amt"
                                                className="form-label"
                                            >
                                                금액
                                            </label>
                                            <input
                                                id="Amt"
                                                name="Amt"
                                                type="text"
                                                className="form-control big-input"
                                                placeholder="금액 입력"
                                                maxLength={12}
                                                value={displayAmt}
                                                onChange={handleAmtChange}
                                            />
                                        </div>
                                    </div>

                                    {/* 구매자명 / 휴대폰번호 */}
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "0.5rem",
                                            width: "100%",
                                        }}
                                    >
                                        <div className="input">
                                            <label
                                                htmlFor="BuyerName"
                                                className="form-label"
                                            >
                                                구매자명
                                            </label>
                                            <input
                                                id="BuyerName"
                                                name="BuyerName"
                                                type="text"
                                                className="form-control big-input"
                                                placeholder="이름 입력"
                                                maxLength={20}
                                                value={formData.BuyerName}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="input">
                                            <label
                                                htmlFor="BuyerHpTel"
                                                className="form-label"
                                            >
                                                휴대폰번호
                                            </label>
                                            <input
                                                id="BuyerHpTel"
                                                name="BuyerHpTel"
                                                type="text"
                                                className="form-control big-input"
                                                placeholder="010-1234-5678"
                                                value={phoneDisplayValue}
                                                onChange={handlePhoneChange}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "0.5rem",
                                            width: "100%",
                                        }}
                                    >
                                        {!isKayu && (
                                        <div
                                            className="input_w_50 input"
                                            style={{ width: "60%" }}
                                        >
                                            <label
                                                htmlFor="IDNo"
                                                className="form-label"
                                            >
                                                생년월일/사업자번호
                                            </label>
                                            <input
                                                id="IDNo"
                                                name="IDNo"
                                                type="text"
                                                className="form-control big-input"
                                                maxLength={13}
                                                placeholder="생년월일/사업자번호"
                                                value={formData.IDNo}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        )}

                                        <div
                                            className="input_w_50 input"
                                            style={{ width: isKayu ? "100%" : "40%" }}
                                        >
                                            <label
                                                htmlFor="CardQuota"
                                                className="form-label"
                                                style={{ width: "100%" }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "space-between",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <div>할부기간</div>
                                                    {!Window &&
                                                        feeImage?.imageUrl && (
                                                            <button
                                                                type="button"
                                                                onClick={() =>
                                                                    setNoticeModal(
                                                                        (e) => !e
                                                                    )
                                                                }
                                                                style={{
                                                                    padding:
                                                                        "0px 5px",
                                                                    fontSize: "11px",
                                                                    fontWeight:
                                                                        "bold",
                                                                    backgroundColor:
                                                                        "#f7f789",
                                                                    border:
                                                                        "1px solid #ccc",
                                                                    borderRadius:
                                                                        "4px",
                                                                    cursor: "pointer",
                                                                    height: "20px",
                                                                }}
                                                            >
                                                                안내
                                                            </button>
                                                        )}
                                                </div>
                                            </label>

                                            <select
                                                id="CardQuota"
                                                name="CardQuota"
                                                className="form-select mt-2 sm:mr-2"
                                                value={formData.CardQuota}
                                                onChange={handleChange}
                                            >
                                                {currentQuotaOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>{option.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="payBt">
                                        <input
                                            id="ec_pay_btn"
                                            className="btn btn-primary mt-3"
                                            type="button"
                                            value={
                                                isSubmitting ? "요청중..." : "요청"
                                            }
                                            onClick={onSubmitSugi}
                                            disabled={isSubmitting || isCardBlocked}
                                        />
                                    </div>
                                </div>
                            </form>

                            {/* PC에서는 우측에 수수료 안내 이미지 표시 */}
                            {Window && feeImage?.imageUrl && (
                                <div
                                    style={{
                                        background: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "20px",
                                    }}
                                >
                                    <img
                                        src={feeImage?.imageUrl ?? ""}
                                        style={{ objectFit: "contain" }}
                                        alt="수수료안내"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function NoticeModal({ feeImage, setNoticeModal }) {
    return (
        <div style={{ background: "#fff", display: 'flex', alignItems: "center", justifyContent: "center", padding: "90px 20px 20px", width: "100%", height: "100%", position: "fixed", top: "0", left: "0", zIndex: "50" }}>
            <div style={{ position: "absolute", top: "75px", right: "10px" }}
                onClick={() => setNoticeModal(false)}><X size={30} /></div>
            <img src={feeImage?.imageUrl ?? ""} style={{ objectFit: "contain", height: "100%" }} />
        </div>
    )
}

export default Sugi;
